import React from "react";

function SprintBacklogTitleList({ selectedItems, colourBlindMode }) {
  const getStatusBackgroundColor = (colourBlindMode, status) => {
    if (colourBlindMode === true) {
        switch (status) {
            case "Active":
                return "bg-[#94B71D]";
            case "Completed":
                return "bg-[#A3C7FF]";
            default:
                return "bg-[#AB9B9F]";
        }
    }
    else {
        switch (status) {
            case "Active":
                return "bg-[#11D000]";
            case "Completed":
                return "bg-[#7DD0FF]";
            default:
                return "bg-[#A49E9E]";
        }
    }
  };

  return (
    <div className="relative items-center flex font-serif-Poppins w-[100%] h-[6vh] mt-[3vh] rounded bg-[#6d6c6c] justify-between">
      <div className="font-sans text-4xl text-white mx-[1vw] my-[1.3vh]">
        {selectedItems.sprintName}
      </div>
      <div className="flex">
        <span className={`${getStatusBackgroundColor(colourBlindMode, selectedItems.sprintStatus)} flex relative w-[8vw] h-[3.6vh] text-white font-semibold text-xl justify-center items-center rounded mx-[1vw] my-[1vh]`}>
          {selectedItems.sprintStatus}
        </span>
      </div>
    </div>
  );


}


export default SprintBacklogTitleList;